import { ConjunctionMode } from "@redotech/redo-customer-segments-common/segments/segment-types";
import {
  ListToListMatchType,
  StringToListMatchType,
} from "@redotech/redo-flows-core-common/condition";
import { OmsConditionType } from "@redotech/redo-flows-core-common/oms-condition-type";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const BomProductConditionLeaf_ = z.object({
  nodeType: z.literal("leaf"),
  conditionType: createEnum(OmsConditionType),
  matchType: z
    .union([createEnum(StringToListMatchType), createEnum(ListToListMatchType)])
    .optional(),
  matchValues: z.array(z.string()).optional(),
  matchValue: z.string().optional(),
  matchKey: z.string().optional(),
});
export const BomProductConditionLeaf: z.ZodType<BomProductConditionLeaf> =
  BomProductConditionLeaf_;
export interface BomProductConditionLeaf extends z.infer<
  typeof BomProductConditionLeaf_
> {}

const BomProductConditionGroup_: z.ZodType<BomProductConditionGroup> = z.lazy(
  () =>
    z.object({
      nodeType: z.literal("group"),
      conjunctionMode: createEnum(ConjunctionMode),
      children: z.array(BomProductConditionNode_),
    }),
);

const BomProductConditionNode_: z.ZodType<BomProductConditionNode> = z.lazy(
  () => z.union([BomProductConditionLeaf_, BomProductConditionGroup_]),
);

export const BomProductConditionNode: z.ZodType<BomProductConditionNode> =
  BomProductConditionNode_;
export type BomProductConditionNode =
  | BomProductConditionLeaf
  | BomProductConditionGroup;

export const BomProductConditionGroup: z.ZodType<BomProductConditionGroup> =
  BomProductConditionGroup_;
export interface BomProductConditionGroup {
  nodeType: "group";
  conjunctionMode: ConjunctionMode;
  children: BomProductConditionNode[];
}

const BomProductConditions_ = z.object({
  conjunctionMode: createEnum(ConjunctionMode),
  children: z.array(BomProductConditionNode_),
});
export const BomProductConditions: z.ZodType<BomProductConditions> =
  BomProductConditions_;
export interface BomProductConditions extends z.infer<
  typeof BomProductConditions_
> {}
